import { render, staticRenderFns } from "./UserProfileQuesAns.vue?vue&type=template&id=15d0a26f"
import script from "./UserProfileQuesAns.vue?vue&type=script&lang=js"
export * from "./UserProfileQuesAns.vue?vue&type=script&lang=js"
import style0 from "./UserProfileQuesAns.vue?vue&type=style&index=0&id=15d0a26f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports